module.exports = __webpack_public_path__ + "static/media/transaction.83ea98c0.png";